import React, { useEffect, useState, lazy, Suspense } from 'react'

import '@fortawesome/fontawesome-svg-core/styles.css'
import '@fontsource/fraunces/600.css'
import '../css/typography.scss'

import Footer from './Footer'
import NavBar from './Navbar'
import './wordpress.css'
import '../css/innerPages.scss'
import '../css/all.sass'
import '../css/index.scss'
import '../css/new.scss'

const BookModal = lazy(() => import('./bookModal'))

function TemplateWrapper({
  children,
  enableModal,
  show,
  classname,
  service,
  showMobileBookNow = false,
}) {
  const [showModal, setshowModal] = useState(false)
  useEffect(() => {
    if (show) {
      setshowModal(show)
    }
  }, [show])
  useEffect(() => {
    if (!showModal && enableModal) {
      enableModal(false)
    }
  }, [showModal])

  return (
    <div className={classname}>
      <NavBar enableModal={setshowModal} />
      <div>{children}</div>
      <Footer />

      <Suspense>
        <BookModal
          show={showModal}
          service={service || children?.props?.acf?.service}
          hideModal={() => {
            setshowModal(false)
          }}
        />
      </Suspense>
      {showMobileBookNow && (
        <div className="mobile-book-modal">
          <button
            type="button"
            onClick={() => setshowModal(true)}
            className="main-btn"
          >
            Book Now
          </button>
        </div>
      )}
    </div>
  )
}

export default TemplateWrapper
